import React, { useMemo } from 'react';
import { useSettings } from '~/hooks/settings';
import IOrder from '~/interfaces/IOrder';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';
import getAddressFormatted from '~/utils/getAddressFormatted';

interface OrderDetailsProps {
  order: IOrder;
  onClose(): void;
}

const OrderDetails: React.FC<OrderDetailsProps> = ({ onClose, order }) => {
  const { company } = useSettings();

  const parseProducts = useMemo(() => {
    return order.products.map(item => ({
      ...item,
    }));
  }, [order]);

  return (
    <>
      <div
        className="modal fade show"
        id="addproductcart"
        tabIndex={-1}
        aria-hidden="true"
        style={{ display: 'block' }}
      >
        <div className="modal-dialog modal-sm modal-dialog-centered">
          <div className="modal-content product border-0 shadow-sm">
            <div className="modal-body">
              <h6
                className="text-color-theme mb-3 text-center"
                style={{ color: company.app_color, textTransform: 'uppercase' }}
              >
                {`Pedido #${order.code}`}
              </h6>

              <div className="row mb-2">
                {parseProducts.map((item, index) => (
                  <div className="col-12 mb-3" key={item.uid}>
                    {/* <div className="card shadow-sm product mb-3">
                      <div className="card-body"> */}
                    <div className="row">
                      <div className="col-auto">
                        <figure
                          className="text-center avatar-90 avatar"
                          style={{ background: `${company.app_color}60` }}
                        >
                          <img
                            src={item.image || company.image}
                            alt="produto"
                          />
                        </figure>
                      </div>
                      <div className="col ps-0">
                        {/* <p className="mb-0">{`${item.quantity}x`}</p> */}
                        <h6
                          className="text-color-theme mb-0"
                          style={{ color: company.app_color }}
                        >
                          {item.name}
                        </h6>
                        <div className="row">
                          <div className="col">
                            <p className="mb-0">
                              {`${item.quantity}x - ${getCurrencyFormatted(
                                parseFloat(item.value),
                              )}`}
                            </p>
                          </div>
                        </div>
                        <p>
                          {item.complements.map(comp => (
                            <>
                              <small className="text-opac">{`${comp.quantity}x - ${comp.item.name}`}</small>
                              <br />
                            </>
                          ))}
                        </p>
                      </div>
                    </div>
                    {/* </div>
                    </div> */}
                  </div>
                ))}
              </div>

              {parseProducts.length > 0 && (
                <form>
                  <div className="row mb-4">
                    <div className="col align-self-center">
                      <h5 className="mb-1">Endereço</h5>
                      <p>{getAddressFormatted(order.address)}</p>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col align-self-center">
                      <h5 className="mb-0">Resumo</h5>
                    </div>
                  </div>

                  <div className="row mb-1">
                    <div className="col">
                      <p>Taxa de entrega</p>
                    </div>
                    <div className="col-auto">
                      {order.address.road
                        ? getCurrencyFormatted(order.shippingCost)
                        : 'Grátis'}
                    </div>
                  </div>
                  <div className="row mb-1">
                    <div className="col">
                      <p>Subtotal</p>
                    </div>
                    <div className="col-auto">
                      {getCurrencyFormatted(order.subtotal)}
                    </div>
                  </div>
                  <div className="row fw-bold mb-1">
                    <div className="mb-3 col-12">
                      <div className="dashed-line" />
                    </div>
                    <div className="col">
                      <p>Total</p>
                    </div>
                    <div className="col-auto">
                      {getCurrencyFormatted(order.total)}
                    </div>
                  </div>
                </form>
              )}
            </div>

            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-link text-color-theme"
                data-bs-dismiss="modal"
                onClick={onClose}
                style={{ color: company.app_color }}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
        <div
          className="modal-backdrop fade show"
          style={{ background: '#00000060' }}
          onClick={onClose}
        />
      </div>
    </>
  );
};

export default OrderDetails;
